<template>
  <section>
    <h2>Methodology</h2>
    <div>
      Data sourced from the Deloitte Football Money League, Forbes and the Swiss
      Ramble. There is a time lag with financial data, so revenue reported for
      the 2021 season is actually from the 2019/20 football season.
    </div>
  </section>
</template>

<style lang="scss" scoped>
section {
  margin: 40px 0px 80px 0px;
  padding: 20px;
  font-style: italic;
}

h2 {
  color:$highlight1;
  font-size:60px;
  @include respond(phone-only) {
    font-size:40px;
  }
}
</style>